import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { updateRequestValue } from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-add-requests',
    templateUrl: './add-requests.component.html',
    styleUrls: ['./add-requests.component.scss'],
})
export class AddRequestsComponent implements OnInit {

    @Input()
    public indexList = [];
    @Input()
    public systemList = [];
    @Input()
    public propertiesList = [];
    @Input()
    public propBskList = [];

    @Input()
    public editorList = [];

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public resultList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;


    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService) {            
        }

    ngOnInit() {
    }

    public async validate(request) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        request.entete.id = 0;
        const wParams = updateRequestValue(request.entete, request.detail);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updaterequest', wParams ));
            wRes.data.entete.description = wRes.data.entete.desc;
            delete wRes.data.entete.desc;
            this.onValidate.emit({ data: wRes.data, duplicate: false });           
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
